import auth from "../../middlewares/auth";

export const supportRequestRoutes = [
    {
        path: '/support-requests',
        component: () => import(/* webpackChunkName: "support_requests" */ '../../views/support_requests/SupportRequest'),
        name: 'support-requests',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['support-request-manage']
        }
    },
    {
        path: '/support-request/:id',
        component: () => import(/* webpackChunkName: "support_requests" */ '../../views/support_requests/SupportRequestForm'),
        name: 'update-support-request',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['support-request-manage']
        }
    },
    {
        path: '/create-support-request',
        component: () => import(/* webpackChunkName: "support_requests" */ '../../views/support_requests/SupportRequestForm'),
        name: 'create-support-request',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['support-request-manage']
        }
    },
    {
        path: '/support-request/:id/show',
        component: () => import(/* webpackChunkName: "support_requests" */ '../../views/support_requests/ViewSupportRequest'),
        name: 'view-support-request',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['support-request-manage']
        }
    },
]